import React from 'react';
import "./App.css";
import Header from './components/Header';
import Hero from './components/Hero';
import SocialProof from './components/SocialProof';
import Services from './components/Services';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import WhyChooseUs from './components/WhyChooseUs';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import StickyFooter from './components/StickyFooter';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <Header />
      <main>
        <Hero />
        <SocialProof />
        <Services />
        <Pricing />
        <Testimonials />
        <WhyChooseUs />
        <ContactForm />
      </main>
      <Footer />
      <StickyFooter />
      {/* Bottom padding for mobile sticky footer */}
      <div className="h-16 md:h-0" />
    </div>
  );
}

export default App;
